import React from 'react'
import { MDBCol, MDBCard, MDBCardBody, MDBCardText } from 'mdbreact'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from 'gatsby-link'
import { CustomLink } from '../utils/helpers.js'

const ResourceCard = ({ id, item, colHeight }) => (
  <MDBCol lg="4" md="6" xs="12" id={id} className="pb-card d-flex">
    {console.log(item)}
    <MDBCard className="flex-fill">
      {(item.link || (item.documents?.length === 1) || item.document) ? (
        <CustomLink link={item.link || item.documents?.[0]?.publicURL || item.documents?.[0]?.url || item.document?.publicURL}>
          <GatsbyImage
            image={item.image.childImageSharp.gatsbyImageData}
            alt={item.alttext}
            className="rounded-top drop-shadow"
          />
        </CustomLink>
      ) : (
        <GatsbyImage
          image={item.image.childImageSharp.gatsbyImageData}
          alt={item.alttext}
          className="rounded-top drop-shadow"
        />
      )}
      <MDBCardBody>
        <div style={colHeight}>
          <h3 className="font-alt font-w-700 letter-spacing-1 title-small title-xs-medium mt-2">
            {item.title}
          </h3>
          <MDBCardText className="font-w-400 text-medium mt-2 mb-2">
            {item.description}
          </MDBCardText>
        </div>
        <hr />
        <div className="card-footer-resource">
          {(item.documents || item.document || item.link) && (
            <>
              {item.documents ? (
                item.documents.map((doc, index) => (
                  <span key={index}>
                    <CustomLink link={doc.document?.publicURL} class="effect">
                      {doc.linktext || item.linktext}
                    </CustomLink>
                    {index < item.documents.length - 1 && <span className="separator"> | </span>}
                  </span>
                ))
              ) : (
                <CustomLink link={item.link || item.document?.publicURL} class="effect">
                  {item.linktext}
                </CustomLink>
              )}
            </>
          )}
        </div>
      </MDBCardBody>
    </MDBCard>
  </MDBCol>
)

export default ResourceCard